module.exports = __webpack_public_path__ + "static/media/toggle-off.aa0ba012.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/photobooks/toggle-off.svg
// module id = 1735
// module chunks = 70